import { z } from 'zod'

import { http } from '@/shared/api'

import type { Notification } from '../model/types'

const itemSchema = z.object({
  ID: z.string(),
  TitleRU: z.string(),
  TitleEN: z.string(),
  BodyRU: z.string(),
  BodyEN: z.string(),
  ReadAt: z.string().nullable(),
  CreatedAt: z.string(),
})

// The endpoint returns a bare array, not the `{ items }` envelope.
const listSchema = z.array(itemSchema).nullable()

const toNotification = (raw: z.infer<typeof itemSchema>): Notification => ({
  id: raw.ID,
  titleRu: raw.TitleRU,
  titleEn: raw.TitleEN,
  bodyRu: raw.BodyRU,
  bodyEn: raw.BodyEN,
  readAt: raw.ReadAt,
  createdAt: raw.CreatedAt,
})

export async function fetchNotifications(
  params: { limit: number; offset: number },
  signal?: AbortSignal,
): Promise<Notification[]> {
  const raw = await http.get('notifications', {
    searchParams: { limit: params.limit, offset: params.offset },
    schema: listSchema,
    signal,
  })

  return (raw ?? []).map(toNotification)
}

const unreadSchema = z.object({ count: z.number() })

export async function fetchUnreadCount(signal?: AbortSignal): Promise<number> {
  const { count } = await http.get('notifications/unread-count', { schema: unreadSchema, signal })
  return count
}

export async function markRead(id: string): Promise<void> {
  await http.patch(`notifications/${id}/read`)
}

export async function markAllRead(): Promise<void> {
  await http.patch('notifications/read-all')
}
